import { Image, NavBar } from 'antd-mobile';
import React from 'react';
import { useNavigate } from 'react-router';
import SingleFlashcardContainer from '../../../components/containers/singleFlashcard';
import { BASE_URL } from '../../../constants/link';
import AudioPlayer from './audioPlayer';
import { ContentWrapper, FlashcardText, Wrapper } from './styles';
import SettingPopup from '../../../components/settingPopup';


function SingleFlashcard({ category, description, name, title, imgUrl, img, audio, index }) {
    const navigate = useNavigate();

    return (
        <SingleFlashcardContainer>
            <Wrapper
                style={{
                    // border: `5px solid var(--border-${name})`,
                    backgroundColor: `var(--bg-${name})`
                }}
            >
                <div>
                    <NavBar
                        // size="large"
                        style={{
                            borderBottom: `1px solid var(--border-${name})`,
                            backgroundColor: `var(--border-${name})`
                        }}
                        // right={<SettingPopup />}
                        onBack={() => {
                            navigate("/");
                        }}
                    >{category}</NavBar>

                    <ContentWrapper>
                        {img && <Image
                            width={200}
                            height={"auto"}
                            src={`${BASE_URL}/img/${img}`} alt={title}
                        />}
                        <FlashcardText>
                            {description}
                        </FlashcardText>
                    </ContentWrapper>
                </div>
                <AudioPlayer {...{ category, description, name, title, audio }} index={index} />
            </Wrapper>
        </SingleFlashcardContainer>
    )
}

export default SingleFlashcard